<div id="<%= dom_id person_option %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Person:</strong>
    <%= person_option.person_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Option:</strong>
    <%= person_option.option_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Table:</strong>
    <%= person_option.table_id %>
  </div>
</div>
